/**
 * Scroll-triggered Slide-in Animations
 * ===================================
 * How to use:
 * 1. Add `scroll-trigger` class to elements you want to animate
 * 2. Add `animate--slide-in` class for slide-up effect
 * 3. Optional: Add `data-cascade` attribute for staggered animations
 * 4. Optional: Set `--animation-order` CSS var to control stagger timing
 *
 * Example:
 * <div class="scroll-trigger animate--slide-in" data-cascade style="--animation-order: 1;">
 *   <!-- Your content -->
 * </div>
 *
 * Note: Animations respect prefers-reduced-motion settings
 */

const SECTION_TRIGGER_CLASS = "section-scroll-trigger";
const ELEMENT_TRIGGER_CLASS = "scroll-trigger";
const ACTIVE_SECTION_CLASS = "section-active";

function onSectionIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const section = entry.target;
      section.classList.add(ACTIVE_SECTION_CLASS);

      // Optional: Unobserve if you only want animation once
      observer.unobserve(section);
    }
  });
}

function initializeScrollAnimations(
  isDesktop,
  rootEl = document,
  isDesignMode = false
) {
  const margin = !isDesktop ? "-20%" : "-50px";
  console.log(margin);
  
  // Initialize section observers
  const sections = Array.from(
    rootEl.getElementsByClassName(SECTION_TRIGGER_CLASS)
  );
  if (sections.length === 0) return;

  if (isDesignMode) {
    sections.forEach((section) => {
      section.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const sectionObserver = new IntersectionObserver(onSectionIntersection, {
    rootMargin: `0px 0px ${margin} 0px`, // Trigger when 20% of section is visible
    threshold: 0.1,
  });

  sections.forEach((section) => sectionObserver.observe(section));

  // Keep your existing element-based triggers for compatibility
  const elements = Array.from(
    rootEl.getElementsByClassName(ELEMENT_TRIGGER_CLASS)
  );
  if (elements.length > 0) {
    const elementObserver = new IntersectionObserver(onIntersection, {
      rootMargin: `0px 0px -50px 0px`,
    });
    elements.forEach((element) => elementObserver.observe(element));
  }
}

// Your existing element-based intersection handler
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains("scroll-trigger--offscreen")) {
        elementTarget.classList.remove("scroll-trigger--offscreen");
        if (elementTarget.hasAttribute("data-cascade")) {
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
        }
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add("scroll-trigger--offscreen");
      element.target.classList.remove("scroll-trigger--cancel");
    }
  });
}

window.addEventListener("DOMContentLoaded", () => {
  const isDesktop = window.matchMedia("(max-width: 999px)").matches;
  initializeScrollAnimations(isDesktop);
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimations(event.target, true)
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimations(document, true)
  );
}

// const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
// const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
// const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// function onIntersection(elements, observer) {
//   elements.forEach((element, index) => {
//     if (element.isIntersecting) {
//       const elementTarget = element.target;
//       if (
//         elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
//       ) {
//         elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//         if (elementTarget.hasAttribute("data-cascade")) {
//           elementTarget.setAttribute("style", `--animation-order: ${index};`);
//         }
//       }
//       observer.unobserve(elementTarget);
//     } else {
//       element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//       element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
//     }
//   });
// }

// function initializeScrollAnimationTrigger(
//   rootEl = document,
//   isDesignModeEvent = false
// ) {
//   const animationTriggerElements = Array.from(
//     rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
//   );
//   if (animationTriggerElements.length === 0) return;

//   if (isDesignModeEvent) {
//     animationTriggerElements.forEach((element) => {
//       element.classList.add("scroll-trigger--design-mode");
//     });
//     return;
//   }

//   const observer = new IntersectionObserver(onIntersection, {
//     rootMargin: "0px 0px -50px 0px",
//   });
//   animationTriggerElements.forEach((element) => observer.observe(element));
// }

// window.addEventListener("DOMContentLoaded", () => {
//   initializeScrollAnimationTrigger();
// });

// if (Shopify.designMode) {
//   document.addEventListener("shopify:section:load", (event) =>
//     initializeScrollAnimationTrigger(event.target, true)
//   );
//   document.addEventListener("shopify:section:reorder", () =>
//     initializeScrollAnimationTrigger(document, true)
//   );
// }
